import React, { memo } from 'react';
import Card from 'react-bootstrap/Card';
import Image from 'react-bootstrap/Image';
import {
  GmbLocalPost,
  LocalPostTopicType,
  LocalPostEventValue,
  LocalPostOfferValue,
  eventStartDateTime,
  eventEndDateTime,
} from '../../../models/gmb-local-post';

// import Eye from '../../general/icons/Eye';

import moment from '../../../utils/moment-ja';

import styled from 'styled-components';

type Props = {
  isLoading: boolean;
  topicType: LocalPostTopicType;
  gmbLocalPost: GmbLocalPost;
  handleModal: () => void;
};

const LocalPostCard = styled(Card)`
  cursor: pointer;
  :hover {
    opacity: 0.5;
  }
`;

const EventCardText = styled(Card.Text)`
  font-size: 12px;
  display: -webkit-box;
`;

const CardHeaderSpan = styled.span`
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
`;

const ImageWrap = styled.div`
  position: relative;
  overflow: hidden;
  text-align: center;
  padding-top: 50%;
`;

const ImageWrapImage = styled(Image)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const UpdateDate = styled.p`
  text-align: right;
  font-size: 12px;
`;

// const CountBox = styled.p`
//   display: flex;
//   justify-content: flex-end;
//   align-items: center;
//   text-align: right;
//   font-size: 12px;
// `;

const BaseRaw: React.FC<Props> = (props) => {
  const { topicType } = props;
  const imageUrl = props.gmbLocalPost.localPost.media[0]
    ? props.gmbLocalPost.localPost.media[0].googleUrl
    : '/images/no_image.png';

  return (
    <LocalPostCard onClick={() => props.handleModal()}>
      <Card.Header>
        <CardHeaderSpan>{props.gmbLocalPost.locationName}</CardHeaderSpan>
      </Card.Header>
      <ImageWrap>
        <ImageWrapImage src={imageUrl} />
      </ImageWrap>
      <Card.Body>
        {[LocalPostEventValue, LocalPostOfferValue].includes(topicType) && (
          <>
            <EventCardText>
              {props.gmbLocalPost.localPost.event?.title || ''}
              <br />
              <br />
              開催日:{eventStartDateTime(props.gmbLocalPost.localPost.event?.schedule)}
              <br />
              終了日:{eventEndDateTime(props.gmbLocalPost.localPost.event?.schedule)}
            </EventCardText>
          </>
        )}
        <UpdateDate>
          {moment(props.gmbLocalPost.localPost.updateTime).format('Y年M月D日(dd)')}
        </UpdateDate>
        {/* <CountBox>
          <Eye />
          <div className="ml-2">{props.gmbLocalPost.viewCount}</div>
        </CountBox> */}
      </Card.Body>
    </LocalPostCard>
  );
};

export default memo(BaseRaw);
